import React, { FC, Fragment, memo, useCallback, useMemo } from 'react'
import { useDialog } from '@ucheba/ui/components/Dialog/bll'
import { Banner } from '../../Banner/desktop'

import { IProgramsProps } from '../types'
import SC from '../base/Programs.styles'
import { ProgramsItem } from './ProgramsItem'
import { ProgramsItemCourse } from './ProgramsItemCourse'
import { useProgramsProgramType } from '../bll'
import EducationalInstitutionAddedNotification from '../../LayoutInstitution/components/WantToStudy/components/EducationalInstitutionAddedNotification/desktop'

const { Block } = SC

const Programs: FC<IProgramsProps> = (props) => {
  const {
    showEducationalInstitutionAddedNotification = false,
    linkTarget = '_blank',
    isBanner = false,
    items,
    programType,
  } = props

  const { isCourses } = useProgramsProgramType(programType || 1002)

  const extraParams = useMemo(
    () => ({
      'programTypes[]': [programType],
    }),
    [programType]
  )
  const { isActive, closeDialog } = useDialog('educationalInstitutionAddedNotificationId')

  const showBanner = useCallback(
    (index: number) => {
      if (isBanner && items && items?.length < 3) {
        return items.length - 1 === index
      }
      if (isBanner && items && items?.length > 9) {
        return index === 2 || index === 9
      }
      if (isBanner && items) {
        return index === 2
      }
      return false
    },
    [items, isBanner]
  )

  if (programType && isCourses) {
    return (
      <>
        <Block>
          {items &&
            items.map((program, index) => {
              const isDivider = index !== 3 && isBanner

              return (
                <Fragment key={program.id}>
                  <ProgramsItemCourse isDivider={isDivider} {...program} />

                  {showBanner(index) && (
                    <li>
                      <Banner id={2} extraParams={extraParams} />
                    </li>
                  )}
                </Fragment>
              )
            })}

          {items && isBanner && items?.length === 0 && (
            <li>
              <Banner id={2} extraParams={extraParams} />
            </li>
          )}
        </Block>

        {showEducationalInstitutionAddedNotification && (
          <EducationalInstitutionAddedNotification
            lsKey='educationalInstitutionAddedNotification'
            open={isActive}
            title='Программа добавлена <br/> в план поступления'
            onClose={closeDialog}
          />
        )}
      </>
    )
  }

  return (
    <>
      <Block>
        {items &&
          items.map((program, index) => {
            const isDivider = index !== 3 && isBanner

            return (
              <Fragment key={program.id}>
                <ProgramsItem
                  linkTarget={linkTarget}
                  isDivider={isDivider}
                  {...program}
                />

                {showBanner(index) && (
                  <li>
                    <Banner id={2} extraParams={extraParams} />
                  </li>
                )}
              </Fragment>
            )
          })}

        {items && isBanner && items?.length === 0 && (
          <li>
            <Banner id={2} extraParams={extraParams} />
          </li>
        )}
      </Block>

      {showEducationalInstitutionAddedNotification && (
        <EducationalInstitutionAddedNotification
          lsKey='educationalInstitutionAddedNotification'
          open={isActive}
          title='Программа добавлена <br/> в план поступления'
          onClose={closeDialog}
        />
      )}
    </>
  )
}

export { Programs }
export default memo(Programs)
